/* Gentle, controllable movement for Selleasy inline add-ons only. */
(() => {
  if (window.bgAddonMotionReady) return;
  window.bgAddonMotionReady = true;
  const states = new WeakMap();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function bind(track) {
    if (states.has(track)) return states.get(track);
    track.closest('.shopify-app-block')?.classList.add('bgp-compact-addon');
    const state = {paused: reduced.matches, stopped: false, until: 0};
    const controls = document.createElement('div');
    controls.className = 'bgp-addon-motion';
    const button = document.createElement('button');
    button.type = 'button';
    const label = () => {
      button.textContent = state.paused || state.stopped ? 'Play' : 'Pause';
      button.setAttribute('aria-label', button.textContent + ' carousel');
      button.title = button.textContent + ' carousel';
    };
    label();
    button.addEventListener('click', () => {
      const resume = state.paused || state.stopped;
      state.paused = !resume;
      state.stopped = false;
      label();
    });
    controls.append(button);
    track.parentElement.after(controls);
    const stop = () => { state.stopped = true; label(); };
    track.addEventListener('change', stop);
    track.addEventListener('pointerdown', () => {state.until = Date.now() + 10000;}, {passive:true});
    track.addEventListener('keydown', () => {state.until = Date.now() + 10000;});
    track.addEventListener('wheel', () => {state.until = Date.now() + 12000;}, {passive:true});
    states.set(track, state);
    return state;
  }
  function tick() {
    document.querySelectorAll('.bgp-hero [id^="lb-carousel-track-"]').forEach(track => {
      const state = bind(track);
      const rect = track.getBoundingClientRect();
      if (state.paused || state.stopped || reduced.matches || document.hidden ||
          Date.now() < state.until || track.matches(':hover') ||
          track.contains(document.activeElement) || rect.bottom < 80 ||
          rect.top > window.innerHeight - 100) return;
      const root = track.closest('.shopify-app-block') || track.parentElement.parentElement;
      const right = root.querySelector('[role="button"][aria-label="Scroll right"]');
      const left = root.querySelector('[role="button"][aria-label="Scroll left"]');
      const usable = button => button && !button.disabled && button.getAttribute('aria-hidden') !== 'true' && !button.hasAttribute('aria-disabled') && button.getBoundingClientRect().width > 0;
      if (usable(right)) right.click();
      else if (usable(left)) left.click();

    });
  }
  tick();
  window.setInterval(tick, 3000);
})();

/* Emphasise the extra savings without changing prices or discount rules. */
(() => {
  function emphasizeSavings() {
    document.querySelectorAll('.bgp-compact-addon').forEach(root => {
      const walker = document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
      const matches = [];
      let node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.includes('20%') && !node.parentElement.closest('strong,script,style')) matches.push(node);
      }
      matches.forEach(text => {
        const pieces = text.nodeValue.split('20%');
        const fragment = document.createDocumentFragment();
        pieces.forEach((part,index) => {
          if(index) {const strong=document.createElement('strong');strong.className='bgp-discount-emphasis';strong.textContent='20%';fragment.append(strong);}
          fragment.append(document.createTextNode(part));
        });
        text.replaceWith(fragment);
      });
    });
  }
  emphasizeSavings();
  window.setInterval(emphasizeSavings,1500);
})();
